
























import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import PageHeader from "@/components/Elements/PageHeader.vue";
import PageFooter from "@/components/Elements/PageFooter.vue";
import PageNavUser from "@/components/Elements/PageNavUser.vue";
import PageBanner from "@/components/Elements/PageBanner.vue";
import Spinner from "@/components/Elements/Spinner.vue";

const AppStore = namespace("App");

@Component({
  components: {
    PageHeader,
    PageFooter,
    PageNavUser,
    PageBanner,
    Spinner
  }
})
export default class App extends Vue {
  public lastScrollPos: number = 0;
  public lastScrollDir: string = "";

  @AppStore.State
  public axiosLoading!: number;

  get loading() {
    return this.axiosLoading > 0 ? true : false;
  }

  async created() {
    await this.$store.dispatch("User/getCurrent");
    await this.$store.dispatch("App/getConfig");
    window.addEventListener("scroll", this.onScroll);
    this.lastScrollPos = window.scrollY;
  }

  destroyed() {
    window.removeEventListener("scroll", this.onScroll);
  }

  onScroll() {
    let dir = "down";
    if (window.scrollY < this.lastScrollPos) {
      dir = "up";
    }
    this.$set(this, "lastScrollDir", dir);
    this.$set(this, "lastScrollPos", window.scrollY);
  }
}
